// Global Production Link Configuration
// Import this wherever you need to use the production API URL

export const PRODUCTION_URL = 'https://he.learninghub.ind.in';
//export const PRODUCTION_URL = 'http://localhost:7001';

// API endpoint helper - appends path to the production URL
export const getApiUrl = (endpoint) => `${PRODUCTION_URL}${endpoint}`;
